import useShiftCoverage from "@/src/modules/shifts/hooks/use-shift-coverage";

/** Poll interval for live on-duty roster (break status, coverage changes). */
export const DISPATCH_COVERAGE_REFETCH_INTERVAL_MS = 30_000;

/** Full shift coverage for the desk — not scoped to the household/property lookup selection. */
export function useDispatchCoverageRows() {
  const coverageQuery = useShiftCoverage(
    {},
    {
      refetchInterval: DISPATCH_COVERAGE_REFETCH_INTERVAL_MS,
      refetchOnWindowFocus: true,
    },
  );
  const rows = coverageQuery.shiftCoverage;

  return {
    ...coverageQuery,
    rows,
    hasCoverage: rows.length > 0,
  };
}
